import * as React from 'react';
import { noop } from '@Utils/facade/lodash';

interface GeneratorContext {
  setGenderGroup: (value: string) => void;
  genderGroup: string;
  generatedNickname: string;
  setGeneratedNickname: (nickname: string) => void;
  isGenerated: boolean;
  setIsGenerated: (value: boolean) => void;
  showErrorMessage: boolean;
  setShowErrorMessage: (value: boolean) => void;
  isCopied: boolean;
  setIsCopied: (value: boolean) => void;
  avatarInput: string;
  setAvatarInput: (value: string) => void;
}

const GeneratorContext = React.createContext<GeneratorContext>({
  setGenderGroup: noop,
  genderGroup: '',
  generatedNickname: '',
  setGeneratedNickname: noop,
  isGenerated: false,
  setIsGenerated: noop,
  showErrorMessage: false,
  setShowErrorMessage: noop,
  isCopied: false,
  setIsCopied: noop,
  avatarInput: '',
  setAvatarInput: noop,
});

export default GeneratorContext;
